

export enum AsyncComponentSharedEnum {
  PublicView = 'PublicView',
  ImageCropper = 'ImageCropper',
  ImageViewWithCropper = 'ImageViewWithCropper',
  ViewDefault = 'ViewDefault',
  ViewList = 'ViewList',
  FormDefault = 'FormDefault',
  ActionMenu = 'ActionMenu',
  ConfirmDelete = 'ConfirmDelete',
  TextField = 'TextField',
  TabManager = 'TabManager',
  Editor = 'Editor',
  ColorAvatar = 'ColorAvatar',
  ColorPicker = 'ColorPicker',
  ProductModelAvatar = 'ProductModelAvatar',
  OptionalAvatar = 'OptionalAvatar',
  Name = 'Name',
  Amount = 'Amount',
  Measure = 'Measure',
  YesNoOptionalSelector = 'YesNoOptionalSelector',
  OptionalDetailAvatar = 'OptionalDetailAvatar',
  MaterialTypeAvatar = 'MaterialTypeAvatar',
  MaterialTypeSelector = 'MaterialTypeSelector',
  QuoteDetailTypeAvatar = 'QuoteDetailTypeAvatar',
  QuoteDetailTypeSelector = 'QuoteDetailTypeSelector',
  SideAvatar = 'SideAvatar',
  SideSelector = 'SideSelector',
  DimensionTypeAvatar = 'DimensionTypeAvatar',
  DimensionTypeSelector = 'DimensionTypeSelector',
  HandleSelector = 'HandleSelector',
  ProductModelOptionalDetailSelector = 'ProductModelOptionalDetailSelector',
  ItemHtml = 'ItemHtml',
  YesNoOptionalText = 'YesNoOptionalText',
  DocStatusAvatar = 'DocStatusAvatar',
  DocStatusSelector = 'DocStatusSelector',
  AddNewBtn = 'AddNewBtn',
  CompanySelector = 'CompanySelector',
  InputType = 'InputType',
  NumberInput = 'NumberInput',
  QuoteTypeAvatar = 'QuoteTypeAvatar',
  QuoteTypeSelector = 'QuoteTypeSelector',
  MultimediaManager = 'MultimediaManager',
  TrueFalseAvatar = 'TrueFalseAvatar',
  AccessoryAvatar = 'AccessoryAvatar',
  PriceSection = 'PriceSection',
  PriceView = 'PriceView',
  LogoAvatar = 'LogoAvatar',
  UserRoleAvatar = 'UserRoleAvatar',
  WelcomeCompanyCard = 'WelcomeCompanyCard',
  MultiActions = 'MultiActions',
  DatePicker = 'DatePicker',
}

export const sharedComponents = {
  [ AsyncComponentSharedEnum.PublicView ]: () => import( '@/components/shared/PublicView.vue' ),
  [ AsyncComponentSharedEnum.ImageCropper ]: () => import( '@/components/shared/ImageCropper.vue' ),
  [ AsyncComponentSharedEnum.ImageViewWithCropper ]: () => import( '@/components/shared/ImageViewWithCropper.vue' ),
  [ AsyncComponentSharedEnum.ViewDefault ]: () => import( '@/components/shared/ViewDefault.vue' ),
  [ AsyncComponentSharedEnum.ViewList ]: () => import( '@/components/shared/ViewList.vue' ),
  [ AsyncComponentSharedEnum.FormDefault ]: () => import( '@/components/shared/FormDefault.vue' ),
  [ AsyncComponentSharedEnum.ActionMenu ]: () => import( '@/components/shared/ActionMenu.vue' ),
  [ AsyncComponentSharedEnum.ConfirmDelete ]: () => import( '@/components/shared/ConfirmDelete.vue' ),
  [ AsyncComponentSharedEnum.TextField ]: () => import( '@/components/shared/TextField.vue' ),
  [ AsyncComponentSharedEnum.TabManager ]: () => import( '@/components/shared/TabManager.vue' ),
  [ AsyncComponentSharedEnum.Editor ]: () => import( '@/components/shared/Editor.vue' ),
  [ AsyncComponentSharedEnum.ColorAvatar ]: () => import( '@/components/shared/ColorAvatar.vue' ),
  [ AsyncComponentSharedEnum.ColorPicker ]: () => import( '@/components/shared/ColorPicker.vue' ),
  [ AsyncComponentSharedEnum.ProductModelAvatar ]: () => import( '@/components/shared/ProductModelAvatar.vue' ),
  [ AsyncComponentSharedEnum.OptionalAvatar ]: () => import( '@/components/shared/OptionalAvatar.vue' ),
  [ AsyncComponentSharedEnum.Name ]: () => import( '@/components/shared/Name.vue' ),
  [ AsyncComponentSharedEnum.Amount ]: () => import( '@/components/shared/Amount.vue' ),
  [ AsyncComponentSharedEnum.Measure ]: () => import( '@/components/shared/Measure.vue' ),
  [ AsyncComponentSharedEnum.YesNoOptionalSelector ]: () => import( '@/components/shared/YesNoOptionalSelector.vue' ),
  [ AsyncComponentSharedEnum.OptionalDetailAvatar ]: () => import( '@/components/shared/OptionalDetailAvatar.vue' ),
  [ AsyncComponentSharedEnum.MaterialTypeAvatar ]: () => import( '@/components/shared/MaterialTypeAvatar.vue' ),
  [ AsyncComponentSharedEnum.MaterialTypeSelector ]: () => import( '@/components/shared/MaterialTypeSelector.vue' ),
  [ AsyncComponentSharedEnum.QuoteDetailTypeAvatar ]: () => import( '@/components/shared/QuoteDetailTypeAvatar.vue' ),
  [ AsyncComponentSharedEnum.QuoteDetailTypeSelector ]: () => import( '@/components/shared/QuoteDetailTypeSelector.vue' ),
  [ AsyncComponentSharedEnum.SideAvatar ]: () => import( '@/components/shared/SideAvatar.vue' ),
  [ AsyncComponentSharedEnum.SideSelector ]: () => import( '@/components/shared/SideSelector.vue' ),
  [ AsyncComponentSharedEnum.DimensionTypeAvatar ]: () => import( '@/components/shared/DimensionTypeAvatar.vue' ),
  [ AsyncComponentSharedEnum.DimensionTypeSelector ]: () => import( '@/components/shared/DimensionTypeSelector.vue' ),
  [ AsyncComponentSharedEnum.HandleSelector ]: () => import( '@/components/shared/HandleSelector.vue' ),
  [ AsyncComponentSharedEnum.ProductModelOptionalDetailSelector ]: () => import( '@/components/shared/ProductModelOptionalDetailSelector.vue' ),
  [ AsyncComponentSharedEnum.ItemHtml ]: () => import( '@/components/shared/ItemHtml.vue' ),
  [ AsyncComponentSharedEnum.YesNoOptionalText ]: () => import( '@/components/shared/YesNoOptionalText.vue' ),
  [ AsyncComponentSharedEnum.DocStatusAvatar ]: () => import( '@/components/shared/DocStatusAvatar.vue' ),
  [ AsyncComponentSharedEnum.DocStatusSelector ]: () => import( '@/components/shared/DocStatusSelector.vue' ),
  [ AsyncComponentSharedEnum.AddNewBtn ]: () => import( '@/components/shared/AddNewBtn.vue' ),
  [ AsyncComponentSharedEnum.CompanySelector ]: () => import( '@/components/shared/CompanySelector.vue' ),
  [ AsyncComponentSharedEnum.InputType ]: () => import( '@/components/shared/InputType.vue' ),
  [ AsyncComponentSharedEnum.NumberInput ]: () => import( '@/components/shared/NumberInput.vue' ),
  [ AsyncComponentSharedEnum.QuoteTypeAvatar ]: () => import( '@/components/shared/QuoteTypeAvatar.vue' ),
  [ AsyncComponentSharedEnum.QuoteTypeSelector ]: () => import( '@/components/shared/QuoteTypeSelector.vue' ),
  [ AsyncComponentSharedEnum.MultimediaManager ]: () => import( '@/components/shared/MultimediaManager.vue' ),
  [ AsyncComponentSharedEnum.TrueFalseAvatar ]: () => import( '@/components/shared/TrueFalseAvatar.vue' ),
  [ AsyncComponentSharedEnum.AccessoryAvatar ]: () => import( '@/components/shared/AccessoryAvatar.vue' ),
  [ AsyncComponentSharedEnum.PriceSection ]: () => import( '@/components/shared/PriceSection.vue' ),
  [ AsyncComponentSharedEnum.PriceView ]: () => import( '@/components/shared/PriceView.vue' ),
  [ AsyncComponentSharedEnum.LogoAvatar ]: () => import( '@/components/shared/LogoAvatar.vue' ),
  [ AsyncComponentSharedEnum.UserRoleAvatar ]: () => import( '@/components/shared/UserRoleAvatar.vue' ),
  [ AsyncComponentSharedEnum.WelcomeCompanyCard ]: () => import( '@/components/dashboards/dashboard1/WelcomeCompanyCard.vue' ),
  [ AsyncComponentSharedEnum.MultiActions ]: () => import( '@/components/shared/MultiActions.vue' ),
  [ AsyncComponentSharedEnum.DatePicker ]: () => import( '@/components/shared/DatePicker.vue' ),
}
